import React, {createContext, useEffect, useState} from "react";
import {Navigate, Route, Routes, useLocation} from 'react-router-dom';
import './styles/App.css'
import NewsPage from "./pages/news/NewsPage";
import EventsPage from "./pages/events/EventsPage";
import HomePage from "./pages/home/HomePage";
import { useLoading } from './components/context/LoadingContext';
import LoginPage from "./pages/auth/login/LoginPage";
import {useAuth} from "./components/context/authContext/AuthContext";
import "bootstrap/dist/css/bootstrap.min.css"
import Header from "./components/header/Header";
import Sidebar from "./components/sidebar/Sidebar";
import SignUpPage from "./pages/auth/signup/SignUpPage";
import NewsEditPage from "./pages/news/NewsEditPage";
import EventEditPage from "./pages/events/EventEditPage";
import EventAthletePreloadPage from "./pages/events/EventAthletePreloadPage";
import ReportsPage from "./pages/reports/ReportsPage";
import ReportEditPage from "./pages/reports/ReportEditPage";
import DistancesPage from "./pages/events/distance/DistancesPage";
import DistanceEditPage from "./pages/events/distance/DistanceEditPage";
import EventTimingResultPage from "./pages/events/EventTimingResultPage";
import EventBadgesPage from "./pages/events/badges/EventBadgesPage";

const SideBarContext = createContext()

function App() {
    const [isLoading, setIsLoading] = useLoading(false);
    const location = useLocation();
    const shouldShowHeader = !(location.pathname === '/login' || location.pathname === '/signUp');
    const [isToggleSidebar, setIsToggleSidebar] = useState(false);
    const values = { isToggleSidebar, setIsToggleSidebar };

    return (
        <SideBarContext.Provider value={values}>
            <div>
                {isLoading && <div className="loader">Загрузка...</div>}
                {shouldShowHeader && <Header />}
                <div className='main d-flex'>
                    {shouldShowHeader && (
                        <div className={`sidebarWrapper ${isToggleSidebar ? 'toggle' : ''}`}>
                            <Sidebar />
                        </div>
                    )}
                    <div className={`content ${!shouldShowHeader ? 'full' : ''} ${isToggleSidebar ? 'toggle' : ''}`}>
                        <Routes>
                            <Route path="/" exact element={<PrivateRoute><HomePage /></PrivateRoute>} />
                            <Route path="/home" exact element={<PrivateRoute><HomePage /></PrivateRoute>} />
                            <Route path="/news" element={<PrivateRoute><NewsPage /></PrivateRoute>} />
                            <Route path="/news/edit/:newsId" element={<PrivateRoute><NewsEditPage /></PrivateRoute>} />
                            <Route path="/events" element={<PrivateRoute><EventsPage /></PrivateRoute>} />
                            <Route path="/events/:eventId/timing" element={<PrivateRoute><EventTimingResultPage /></PrivateRoute>} />
                            <Route path="/events/:eventId/badges" element={<PrivateRoute><EventBadgesPage /></PrivateRoute>} />
                            <Route path="/events/:eventId/distances" element={<PrivateRoute><DistancesPage /></PrivateRoute>} />
                            <Route path="/events/:eventId/distances/:distanceId" element={<PrivateRoute><DistanceEditPage /></PrivateRoute>} />
                            <Route path="/events/edit/:eventId" element={<PrivateRoute><EventEditPage /></PrivateRoute>} />
                            <Route path="/events/addAthletes/:eventId" element={<PrivateRoute><EventAthletePreloadPage /></PrivateRoute>} />
                            <Route path="/reports" element={<PrivateRoute><ReportsPage /></PrivateRoute>} />
                            <Route path="/reports/edit/:reportId" element={<PrivateRoute><ReportEditPage /></PrivateRoute>} />
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/signUp" element={<SignUpPage />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </SideBarContext.Provider>
    );
}

export default App;
export {SideBarContext}

const PrivateRoute = ({ children }) => {
    const { currentUser } = useAuth();

    return currentUser ? children : <Navigate to="/login" />;
};